import * as React from 'react';
import './styles.css';
import { Tag, TagProps } from 'antd';
import { SelectProps } from 'antd/lib';
export interface IBaseTagProps extends TagProps {}

export default function BaseTag({ children, ...props }: IBaseTagProps) {
  return (
    <Tag color="cyan" {...props}>
      {children}
    </Tag>
  );
}

export type TagRender = SelectProps['tagRender'];

export const tagRender: TagRender = (props) => {
  const { label, closable, onClose } = props;
  const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <BaseTag onMouseDown={onPreventMouseDown} closable={closable} onClose={onClose} style={{ marginRight: 3 }}>
      {label}
    </BaseTag>
  );
};
